// extracted by mini-css-extract-plugin
export default {"header":"Table_header__aMTSN","link":"Table_link__iEjnu","active":"Table_active__G76qW","inactive":"Table_inactive__Pkf4y"};